// JavaScript Document

function initwebpAnimations() {


    const animationHolderers = document.querySelectorAll('.webp-animation-holder');

    animationHolderers.forEach(animationHolderer => {

        const previewPNG            = animationHolderer.querySelector('.webp-animation-preview');
        const webpAnimation         = animationHolderer.querySelector('.webp-animation-movie');
        const webpAnimationSrc      = webpAnimation.dataset.src;

        function play() {
            //console.log('play');
            previewPNG.classList.add('d-none');
            webpAnimation.classList.remove('d-none');
            webpAnimation.src = webpAnimationSrc;
        }

        function reset() {
            //console.log('reset');
            previewPNG.classList.remove('d-none');
            webpAnimation.classList.add('d-none');
            webpAnimation.src = '';
        }

        ScrollTrigger.create({
            trigger: animationHolderers,
              start: "top bottom", // when the top of the trigger hits the top of the viewport
              end: "bottom top",
            scrub: true,
            onEnter: () => play(),
            //onLeave: () => reset(),
            //onEnterBack: () =>play(),
            onLeaveBack: () => reset(),
        });


    });
}
